import * as React from 'react'

import { cn } from '@/utils/index'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  // `motion-reduce:animate-none`: with "reduce motion" on, a skeleton is a static placeholder.
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted motion-reduce:animate-none', className)}
      {...props}
    />
  )
}

export { Skeleton }
